<template>
  <div class="bg-white">
    <CoverPage />
    <Calendar />
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <div class="absolute -top-56 right-8 md:block lg:block hidden">
        <img
          src="./../../../assets/images/bg-des/footer-bg.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import Calendar from "./components/Calendar2.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
export default {
  components: {
    CoverPage,
    Calendar,
    Footer,
    DownloadApp,
  },
};
</script>
